import { useState, useEffect } from 'react'
import supabase from './supabase'
import Login from './components/Login'
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { Navigate } from 'react-router-dom';

//import RoutersArr from './routes';
import LeftToolbar from './components/LeftToolbar';
import DashbordTop from './components/DashbordTop';
import DashboardLayout from './components/DashboardLayout/DashboardLayout';

//import{useTheme} from './hooks/useTheme';
//import{useScreen} from './hooks/setScreenSize';

import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import setThemeObj from './hooks/useThemeMUI';
import { useMediaQuery } from '@mui/material';
//import useTheme from '@mui/material/styles';
import MDBoxRoot from './components/MDBox/MDBoxRoot';

import ClassesList from './components/ClassesList';
import PackagesList from './components/PackagesList';
import AdminsList from './components/AdminsList';
import Reports from './components/Reports';
import StudentsList from './components/StudentsList';
import Calendar from './components/Calendar';
import EditEvent from './components/EditEvent';
import AddEvent from './components/AddEvent';
import Dashboard from './components/Dashboard';
import EditStudentDialog, { NewStudentDialog } from './components/EditStudentDialog';
import ResetPassword2 from './components/ResetPassword';
import { gql, useQuery } from '@apollo/client';

import { ScreenSizeProvider } from "./hooks/ScreenSizeContext";
import Configuration from './components/Configuration';
//import './css/App.css';
//import './css/Responsive.css';
//import './css/Themes.css';

function App() {

  const getAdminStatus = gql(`
    query GetAdminStatusR {
      am_i_admin
    }
    `);

  const getStaffStatus = gql(`
    query GetStaffStatusR {
      am_i_staff
    }
    `);

  const { data: admin_flag, refetch: refetchAdmin } = useQuery(getAdminStatus, {
    fetchPolicy: 'network-only', // Doesn't check cache before making a network request
  });
  const { data: staff_flag, refetch: refetchStaff } = useQuery(getStaffStatus, {
    fetchPolicy: 'network-only', // Doesn't check cache before making a network request
  });
  const staff = staff_flag?.am_i_staff;
  const admin = admin_flag?.am_i_admin;

  const [toolbarWidth, setToolbarWidth] = useState<number>(200);
  const isSmallScreen = useMediaQuery(setThemeObj.breakpoints.down('sm'));
  //console.log(setThemeObj.breakpoints.down('sm'));
  //console.log (useMediaQuery(setThemeObj.breakpoints.up('sm')));
  const isUnderMediumScreen = useMediaQuery(setThemeObj.breakpoints.between('sm', 'md'));

  useEffect(() => {
    const toolbarElement = document.getElementById('left-toolbar');
    console.log('Toolbar element:', toolbarElement); 
    if (isSmallScreen) {
      setToolbarWidth(40)
    };

    if (toolbarElement) {
      //console.log('Toolbar width:', toolbarElement.clientWidth);
      setToolbarWidth(toolbarElement.clientWidth);
    } else {
      //console.warn('Element with id "left-toolbar" not found');
    }
  }, []);

  const [session, setSession] = useState(null);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      refetchAdmin(); // Re-fetch when location changes
      refetchStaff();
    })

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
      refetchAdmin(); // Re-fetch when location changes
      refetchStaff();
    })
    return () => subscription.unsubscribe()
  }, [])

  //if (!session) {
  //return (<Auth supabaseClient={supabase} appearance={{ theme: ThemeSupa }} />)
  //  return <Login />
  //}

  return (
    <ThemeProvider theme={setThemeObj}>
      <ScreenSizeProvider>
        {session ? (
          <>
            <MDBoxRoot sx={{ display: 'flex', width: '100%' }}>
              <BrowserRouter>
                <CssBaseline />
                <Routes>
                  <Route path='/reset_password' element={<ResetPassword2 />} />
                  <Route path="/" element={<Navigate to="/dashboard" />} />
                  <Route path='*' element={
                    <>
                      <LeftToolbar id='left-toolbar' wthT={toolbarWidth} isSmallScreen={isSmallScreen} />
                      <DashboardLayout owntheme={setThemeObj} wthT={toolbarWidth} >
                        <DashbordTop wthT={toolbarWidth} key='DT' />
                        <Routes>
                          <Route path="/dashboard" element={<Dashboard wthT={toolbarWidth} isSmallScreen={isSmallScreen} />} />
                          {staff && (<Route path='classes' element={<ClassesList />} />)}
                          {staff && (<Route path='packages' element={<PackagesList />} />)}
                          <Route path='calendar' element={<Calendar />} />
                          <Route path='calendar/:day' element={<Calendar />} />

                          {staff && (<Route path='calendar/:day/new' element={<AddEvent />} />)}
                          <Route path='calendar/:day/:eventId' element={<EditEvent />} />
                          {staff && (<Route path='students' element={<StudentsList />} />)}
                          {staff && (<Route path='students/new' element={<NewStudentDialog />} />)}
                          {staff && (<Route path='students/:studentId' element={<EditStudentDialog />} />)}
                          {admin && (<Route path='admins' element={<AdminsList />} />)}
                          {staff && (<Route path='reports' element={<Reports />} />)}
                          {admin && (<Route path='config' element={<Configuration />} />)}
                        </Routes>
                      </DashboardLayout>
                    </>} />
                </Routes>
              </BrowserRouter>
            </MDBoxRoot>
          </>
        ) : (
          <BrowserRouter>
            <Login />
          </BrowserRouter>
        )}
      </ScreenSizeProvider>
    </ThemeProvider>
  );
}

//                        {/*RoutersArr.map((item, index) => (
//          <Route path={item.key }element={item.component }key={item.key }/>
//         ))*/}

export default App;
